import React, { useState, useEffect } from 'react';
import { oilArt } from '../../i18n/oilArt';

const STEPS = [
  'Abrindo os portões do porto…',
  'Acendendo as torres de perfuração…',
  'Contando as moedas do cofre…',
  'Chamando os capangas para a mesa…',
  'Afinando a orquestra do cassino…',
  'Polindo os barris de petróleo…',
  'Preparando os cartazes dos procurados…',
];

export default function OilLoading({ progress, onEnter }) {
  const [step, setStep] = useState(0);
  const locale = localStorage.getItem('oil_locale') || 'pt';

  useEffect(() => {
    const t = setInterval(() => setStep((s) => (s + 1) % STEPS.length), 1400);
    return () => clearInterval(t);
  }, []);

  const ready = progress >= 100;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-[#05070b]"
      data-testid="oil-loading">
      <div className="relative flex h-full w-full max-w-md flex-col items-center justify-center overflow-hidden bg-[#07070a] md:border-x md:border-amber-900/40 md:shadow-[0_0_80px_rgba(0,0,0,0.95)]">
      <img src={oilArt('hero', locale)} alt="" className="absolute inset-0 h-full w-full object-cover object-top opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />

      <div className="relative z-10 w-full max-w-[340px] px-6 text-center">
        <p className="text-[10px] font-black uppercase tracking-[0.4em] text-amber-500">Oil Tycoon</p>
        <p className="mt-1 text-lg font-black uppercase tracking-[0.2em] text-amber-200">A Bolsa do Petróleo</p>

        <div className="mt-7 h-3 w-full overflow-hidden rounded-full border border-amber-800/70 bg-black/80">
          <div className="h-full rounded-full bg-gradient-to-r from-[#8a5a10] via-amber-400 to-[#ffe9a8] transition-[width] duration-300"
            style={{ width: `${Math.max(3, progress)}%`, boxShadow: '0 0 12px rgba(255,190,60,0.7)' }}
            data-testid="oil-loading-bar" />
        </div>
        <p className="mt-2 text-xs font-black text-amber-300" data-testid="oil-loading-pct">{progress}%</p>
        <p className="mt-1 h-4 text-[10px] font-bold text-zinc-400" data-testid="oil-loading-step">
          {ready ? 'Tudo pronto, magnata.' : STEPS[step]}
        </p>

        <button onClick={onEnter} disabled={!ready} data-testid="oil-loading-enter"
          className={`mt-7 w-full rounded-full border py-3 text-[11px] font-black uppercase tracking-[0.3em] transition-all ${
            ready
              ? 'border-amber-400 bg-gradient-to-b from-[#3a2708] to-black text-amber-200 shadow-[0_0_18px_rgba(255,190,60,0.55)] active:scale-95'
              : 'cursor-not-allowed border-zinc-800 bg-black/60 text-zinc-600'}`}>
          {ready ? 'Entrar' : 'Carregando…'}
        </button>
      </div>
      </div>
    </div>
  );
}
